// extracted by mini-css-extract-plugin
module.exports = {"Optin":"Optin_Optin__3PKaA","OptinBox":"Optin_OptinBox__2RG-a"};